import create from "zustand";

interface OpenAccountStoreState {
    isOpen: boolean;
    show: () => void;
    hide: () => void;
}

/**
 * Zustand store for managing the OpenAccountModal visibility state.
 *
 * This store is necessary because the OpenAccountModal is triggered from multiple locations:
 * 1. Dashboard Sidebar > More Accounts button (user clicks the button to open modal)
 * 2. Globally via hotkeys (Cmd + O on macOS, Ctrl + O on Windows/Linux)
 *
 * By centralizing the modal state in Zustand, we ensure that the same modal instance
 * is reused across both entry points, maintaining consistent state and preventing
 * duplicate modal instances. This also allows the hotkey handler to communicate
 * with the modal component without direct prop drilling.
 */
export const useOpenAccountStore = create<OpenAccountStoreState>((set) => ({
    isOpen: false,
    show: () => set({ isOpen: true }),
    hide: () => set({ isOpen: false }),
}));
